import Enum from "./Enum";

export default Enum.create( {
	ONETIME_SCHEDULED_MEETING: "oneTimeScheduledMeeting",
	RECURRING_SCHEDULED_MEETING: "recurringScheduledMeeting",
	SCHEDULED_MEETING: "scheduledMeeting",
	QUICK_MEETING: "quickMeeting",
	PRIVATE_NOTE: "privateNote",
	SHARED_NOTE: "sharedNote",
	AI_CONTENT: "aiContent",
} );
